export interface CountryState {
  countrySelected: string;
}

export const initialState: CountryState = { countrySelected: null };
